const types = {
  SET_REV: 'SET_REV',
  SET_CHALLENGES: 'SET_CHALLENGES',
  SET_AVAILABLE_OWNERS: 'SET_AVAILABLE_OWNERS',
  SET_AVAILABLE_COACHES: 'SET_AVAILABLE_COACHES',
  SET_AVAILABLE_COLLABORATORS: 'SET_AVAILABLE_COLLABORATORS',
}

export default types
